import React, { useEffect } from "react";
import { useSiteFlags } from "./BrandedSection";

/**
 * Reserved ad placeholder only; no real AdSense publisher ID or wiring is added here.
 */
export default function AdSlot({
  client = "ca-pub-XXXXXXXXXXXXXXXX",
  slot = "default",
  format = "auto",
  label = "sponsored",
  style = {},
  className = "",
  responsive = true,
}) {
  const { ads_enabled: adsEnabled } = useSiteFlags();
  const slotHeight = slot.includes("article") ? 260 : slot.includes("home") ? 90 : 120;

  useEffect(() => {
    if (!adsEnabled) {
      document.querySelector('script[data-onemedia-adsense="true"]')?.remove();
      return undefined;
    }
    if (!document.querySelector('script[data-onemedia-adsense="true"]')) {
      const script = document.createElement("script");
      script.async = true;
      script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${client}`;
      script.crossOrigin = "anonymous";
      script.dataset.onemediaAdsense = "true";
      document.head.appendChild(script);
    }
    try {
      if (!window.adsbygoogle) {
        window.adsbygoogle = [];
      }
      window.adsbygoogle.push({});
    } catch (err) {
      // In dev or blocked browser contexts, silently ignore.
    }
  }, [adsEnabled, slot, client, format]);

  if (!adsEnabled) return null;

  return (
    <div
      className={`xs-ad-slot ${className}`.trim()}
      data-testid={`ad-slot-${slot}`}
      style={{
        margin: "20px 0",
        minHeight: slotHeight,
        height: slotHeight,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        ...style,
      }}
    >
      <ins
        className="adsbygoogle"
        style={{ display: "block", width: "100%", height: "100%", minHeight: slotHeight }}
        data-ad-client={client}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive={responsive ? "true" : "false"}
      />
      <small style={{ display: "block", opacity: 0.75, marginTop: 8, textAlign: "center" }}>— {label} —</small>
    </div>
  );
}
